// import React, {
//   useEffect,
//   useState,
// } from "react";

// import "./Myproject.css";

// import {
//   Globe,
//   KeyRound,
//   Layers3,
//   CalendarDays,
//   Eye,
//   X,
//   Copy,
//   CheckCircle2,
// } from "lucide-react";

// import { getPMProjects } from "../../../services/PmProjectService";


// function MyProjects() {
//   const [projects, setProjects] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedProject, setSelectedProject] = useState(null);
//   const [copied, setCopied] = useState(null);

//   useEffect(() => {
//     fetchProjects();
//   }, []);

//   const fetchProjects = async () => {
//     try {
//       setLoading(true);
//       const response = await getPMProjects();
//       setProjects(response || []);
//     } catch (error) {
//       console.error("Error fetching PM projects:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const copyApiKey = (key) => {
//     navigator.clipboard.writeText(key);
//     setCopied(key);

//     setTimeout(() => {
//       setCopied(null);
//     }, 2000);
//   };

//   const formatDate = (date) => {
//     if (!date) return "--";

//     return new Date(date).toLocaleDateString("en-IN", {
//       day: "numeric",
//       month: "short",
//       year: "numeric",
//     });
//   };

//   return (
//     <div className="pm-projects-page">
//       {/* HEADER */}
//       <div className="pm-projects-header">
//         <div>
//           <h1>My Projects</h1>
//           <p>
//             View and manage all approved communication projects assigned to you
//           </p>
//         </div>

//         <div className="pm-project-total-card">
//           <span>Total Projects</span>
//           <h2>{projects.length}</h2>
//         </div>
//       </div>

//       {/* STATS */}
//       <div className="pm-project-stats-grid">
//         <div className="pm-project-stat-card">
//           <div>
//             <span>Approved Projects</span>
//             <h2>
//               {
//                 projects.filter((p) => p.status === "APPROVED").length
//               }
//             </h2>
//           </div>

//           <CheckCircle2 size={28} />
//         </div>

//         <div className="pm-project-stat-card">
//           <div>
//             <span>Total Templates</span>
//             <h2>
//               {projects.reduce(
//                 (acc, item) => acc + (item.configs?.length || 0),
//                 0
//               )}
//             </h2>
//           </div>

//           <Layers3 size={28} />
//         </div>

//         <div className="pm-project-stat-card">
//           <div>
//             <span>Active APIs</span>
//             <h2>
//               {
//                 projects.filter((p) => p.api_key).length
//               }
//             </h2>
//           </div>

//           <KeyRound size={28} />
//         </div>
//       </div>

//       {/* PROJECT LIST */}
//       <div className="pm-projects-grid">
//         {loading ? (
//           <div className="pm-loading-state">
//             <p>Loading projects...</p>
//           </div>
//         ) : projects.length === 0 ? (
//           <div className="pm-empty-state">
//             <h3>No Projects Found</h3>
//             <p>No approved projects assigned yet.</p>
//           </div>
//         ) : (
//           projects.map((project) => (
//             <div
//               key={project.id}
//               className="pm-project-card"
//             >
//               {/* TOP */}
//               <div className="pm-project-card-top">
//                 <div>
//                   <h3>{project.name}</h3>

//                   <span className="pm-project-status approved">
//                     {project.status}
//                   </span>
//                 </div>
//               </div>

//               {/* URL */}
//               <div className="pm-project-url">
//                 <Globe size={16} />
//                 <span title={project.base_url}>
//                   {project.base_url}
//                 </span>
//               </div>

//               {/* MINI INFO */}
//               <div className="pm-project-mini-info">
//                 <div>
//                   <span>Templates</span>
//                   <h4>{project.configs?.length || 0}</h4>
//                 </div>

//                 <div>
//                   <span>Approved On</span>
//                   <h4>
//                     {formatDate(project.approved_date)}
//                   </h4>
//                 </div>
//               </div>

//               {/* BUTTON */}
//               <button
//                 className="view-project-btn"
//                 onClick={() =>
//                   setSelectedProject(project)
//                 }
//               >
//                 <Eye size={16} />
//                 View Details
//               </button>
//             </div>
//           ))
//         )}
//       </div>

//       {/* DETAILS MODAL */}
//       {selectedProject && (
//         <div className="project-modal-overlay">
//           <div className="project-modal-card">
//             <button
//               className="close-modal-btn"
//               onClick={() =>
//                 setSelectedProject(null)
//               }
//             >
//               <X size={18} />
//             </button>

//             <div className="project-modal-header">
//               <h2>{selectedProject.name}</h2>

//               <span className="pm-project-status approved">
//                 {selectedProject.status}
//               </span>
//             </div>

//             <div className="project-modal-content">
//               <div className="project-detail-row">
//                 <label>Base URL</label>
//                 <p>{selectedProject.base_url}</p>
//               </div>

//               <div className="project-detail-row">
//                 <label>Requested Date</label>
//                 <p>
//                   {formatDate(
//                     selectedProject.request_date
//                   )}
//                 </p>
//               </div>

//               <div className="project-detail-row">
//                 <label>Approved Date</label>
//                 <p>
//                   {formatDate(
//                     selectedProject.approved_date
//                   )}
//                 </p>
//               </div>

//               <div className="project-detail-row">
//                 <label>API Key</label>

//                 <div className="api-key-box">
//                   <span>
//                     {selectedProject.api_key ||
//                       "No API key"}
//                   </span>

//                   {selectedProject.api_key && (
//                     <button
//                       onClick={() =>
//                         copyApiKey(
//                           selectedProject.api_key
//                         )
//                       }
//                     >
//                       {copied ===
//                       selectedProject.api_key ? (
//                         <CheckCircle2 size={16} />
//                       ) : (
//                         <Copy size={16} />
//                       )}
//                     </button>
//                   )}
//                 </div>
//               </div>

//               <div className="project-detail-row">
//                 <label>Templates</label>

//                 <div className="template-list">
//                   {selectedProject.configs?.map(
//                     (config) => (
//                       <div
//                         key={config.id}
//                         className="template-chip"
//                       >
//                         <div>
//                           <h4>
//                             {config.template_name}
//                           </h4>

//                           <span>
//                             {config.design_name}
//                           </span>
//                         </div>

//                         <small>
//                           {config.channel_type}
//                         </small>
//                       </div>
//                     )
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default MyProjects;




import React, { useEffect, useState } from "react";
import "./Myproject.css";
import {
  Globe,
  KeyRound,
  Layers3,
  Eye,
  X,
  Copy,
  CheckCircle2,
  ArrowLeft,
} from "lucide-react";
import { getPMProjects } from "../../../services/PmProjectService";

// Local development host fallback if absolute URIs are not sent natively from the API
const BACKEND_URL = 'http://127.0.0.1:8000';

function MyProjects() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedProject, setSelectedProject] = useState(null);
  const [copied, setCopied] = useState(null);
  
  // State hook to track image asset load failures cleanly within React's lifecycle
  const [imageErrors, setImageErrors] = useState({});

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      setLoading(true);
      const response = await getPMProjects();
      setProjects(response || []);
    } catch (error) {
      console.error("Error fetching PM projects:", error);
    } finally {
      setLoading(false);
    }
  };

  // Safe image path resolution mapping utility
  const getProjectLogo = (logoUrl) => {
    if (!logoUrl) return null;
    if (logoUrl.startsWith('http://') || logoUrl.startsWith('https://')) {
      return logoUrl;
    }
    if (logoUrl.startsWith('/')) {
      return `${BACKEND_URL}${logoUrl}`;
    }
    return `${BACKEND_URL}/media/${logoUrl}`;
  };

  const copyApiKey = (key) => {
    if (!key) return;
    navigator.clipboard.writeText(key);
    setCopied(key);
    setTimeout(() => {
      setCopied(null);
    }, 2000);
  };

  const formatDate = (date) => {
    if (!date) return "--";
    return new Date(date).toLocaleDateString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  const handleImageError = (projectId) => {
    setImageErrors((prev) => ({
      ...prev,
      [projectId]: true,
    }));
  };

  return (
    <div className="pm-projects-page">
      {/* HEADER */}
      <div className="pm-projects-header">
        <div>
          <h1>My Projects</h1>
          <p>View and manage all approved communication projects assigned to you</p>
        </div>

        <div className="pm-project-total-card">
          <span>Total Projects</span>
          <h2>{projects.length}</h2>
        </div>
      </div>

      {/* STATS */}
      <div className="pm-project-stats-grid">
        <div className="pm-project-stat-card">
          <div>
            <span>Approved Projects</span>
            <h2>{projects.filter((p) => p.status === "APPROVED").length}</h2>
          </div>
          <CheckCircle2 size={28} />
        </div>

        <div className="pm-project-stat-card">
          <div>
            <span>Total Templates</span>
            <h2>
              {projects.reduce((acc, item) => acc + (item.configs?.length || 0), 0)}
            </h2>
          </div>
          <Layers3 size={28} />
        </div>

        <div className="pm-project-stat-card">
          <div>
            <span>Active APIs</span>
            <h2>{projects.filter((p) => p.api_key).length}</h2>
          </div>
          <KeyRound size={28} />
        </div>
      </div>

      {/* PROJECT LIST */}
      <div className="pm-projects-grid">
        {loading ? (
          <div className="pm-loading-state">
            <p>Loading projects...</p>
          </div>
        ) : projects.length === 0 ? (
          <div className="pm-empty-state">
            <h3>No Projects Found</h3>
            <p>No approved projects assigned yet.</p>
          </div>
        ) : (
          projects.map((project) => (
            <div key={project.id} className="pm-project-card">
              {/* TOP CARD DETAILS WITH LOGO */}
              <div className="pm-project-card-top">
                <div className="pm-project-logo-wrapper" style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '15px' }}>
                  {project.logo_url && !imageErrors[project.id] ? (
                    <img 
                      src={getProjectLogo(project.logo_url)} 
                      alt={`${project.name} logo`} 
                      style={{ width: '45px', height: '45px', borderRadius: '8px', objectFit: 'cover', border: '1px solid #e2e8f0' }}
                      onError={() => handleImageError(project.id)}
                    />
                  ) : (
                    <div className="pm-logo-placeholder" style={{ width: '45px', height: '45px', background: '#e2e8f0', color: '#1e3a8a', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '8px', fontWeight: 'bold', fontSize: '18px' }}>
                      {project.name ? project.name.charAt(0) : "P"}
                    </div>
                  )}
                  <div>
                    <h3 style={{ margin: 0, fontSize: '18px' }}>{project.name}</h3>
                    <span className="pm-project-status approved">{project.status}</span>
                  </div>
                </div>
              </div>

              {/* URL */}
              <div className="pm-project-url">
                <Globe size={16} />
                <span title={project.base_url}>{project.base_url}</span>
              </div>

              {/* MINI INFO */}
              <div className="pm-project-mini-info">
                <div>
                  <span>Templates</span>
                  <h4>{project.configs?.length || 0}</h4>
                </div>

                <div>
                  <span>Approved On</span>
                  <h4>{formatDate(project.approved_date)}</h4>
                </div>
              </div>

              {/* BUTTON */}
              <button
                className="view-project-btn"
                onClick={() => setSelectedProject(project)}
              >
                <Eye size={16} />
                View Details
              </button>
            </div>
          ))
        )}
      </div>

      {/* DETAILS MODAL Container */}
      {selectedProject && (
        <div className="project-modal-overlay" onClick={() => setSelectedProject(null)}>
          <div className="project-modal-card" onClick={(e) => e.stopPropagation()}>
            <button
              className="close-modal-btn"
              onClick={() => setSelectedProject(null)}
              aria-label="Close Modal"
            >
              <X size={18} />
            </button>

            {/* MODAL HEADER WITH LOGO INTEGRATION */}
            <div className="project-modal-header" style={{ display: 'flex', alignItems: 'center', gap: '16px', borderBottom: '1px solid #e2e8f0', paddingBottom: '15px', position: 'relative' }}>
              {selectedProject.logo_url && !imageErrors[`modal-${selectedProject.id}`] ? (
                <img 
                  src={getProjectLogo(selectedProject.logo_url)} 
                  alt={selectedProject.name} 
                  style={{ width: '60px', height: '60px', borderRadius: '12px', objectFit: 'cover', border: '1px solid #cbd5e1' }}
                  onError={() => handleImageError(`modal-${selectedProject.id}`)}
                />
              ) : (
                <div className="pm-modal-logo-placeholder" style={{ width: '60px', height: '60px', background: '#e2e8f0', color: '#1e3a8a', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '12px', fontWeight: 'bold', fontSize: '24px' }}>
                  {selectedProject.name ? selectedProject.name.charAt(0) : "P"}
                </div>
              )}
              <div>
                <h2 style={{ margin: 0, paddingRight: '24px' }}>{selectedProject.name}</h2>
                <span className="pm-project-status approved">{selectedProject.status}</span>
              </div>
            </div>

            <div className="project-modal-content" style={{ marginTop: '20px' }}>
              <div className="project-detail-row">
                <label>Base URL</label>
                <p>{selectedProject.base_url}</p>
              </div>
<div className="project-detail-row">
  <label>Sender Name</label>
  <p>{selectedProject.sender_name || "--"}</p>
</div>

<div className="project-detail-row">
  <label>Sender Email</label>
  <p>{selectedProject.sender_email || "--"}</p>
</div>
              <div className="project-detail-row">
                <label>Requested Date</label>
                <p>{formatDate(selectedProject.request_date)}</p>
              </div>

              <div className="project-detail-row">
                <label>Approved Date</label>
                <p>{formatDate(selectedProject.approved_date)}</p>
              </div>

              <div className="project-detail-row">
                <label>API Key</label>
                <div className="api-key-box">
                  <span>{selectedProject.api_key || "No API key"}</span>
                  {selectedProject.api_key && (
                    <button onClick={() => copyApiKey(selectedProject.api_key)} type="button">
                      {copied === selectedProject.api_key ? (
                        <CheckCircle2 size={16} color="#10b981" />
                      ) : (
                        <Copy size={16} />
                      )}
                    </button>
                  )}
                </div>
              </div>

              <div className="project-detail-row">
                <label>Templates ({selectedProject.configs?.length || 0})</label>
                <div className="template-list">
                  {selectedProject.configs && selectedProject.configs.length > 0 ? (
                    selectedProject.configs.map((config) => (
                      <div key={config.id} className="template-chip">
                        <div>
                          <h4>{config.template_name}</h4>
                          <span>{config.design_name}</span>
                        </div>
                        <small>{config.channel_type}</small>
                      </div>
                    ))
                  ) : (
                    <p style={{ color: '#64748b', fontSize: '0.9rem', fontStyle: 'italic' }}>No configs attached to this project.</p>
                  )}
                </div>
              </div>
            </div>

            {/* FOOTER NAVIGATION BUTTONS FOR EASIER USER EXIT */}
            <div className="project-modal-footer" style={{ borderTop: '1px solid #e2e8f0', marginTop: '25px', paddingTop: '15px', display: 'flex', justifyContent: 'flex-end' }}>
              <button 
                type="button"
                className="view-project-btn" 
                onClick={() => setSelectedProject(null)}
                style={{ background: '#64748b', color: '#fff', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}
              >
                <ArrowLeft size={16} />
                Back to Projects
              </button>
            </div>

          </div>
        </div>
      )}
    </div>
  );
}

export default MyProjects;